const removeDuplicates = <T>(array: T[]): T[] => Array.from(new Set(array));

export default removeDuplicates;
